<template>
  <AuthLayout>
    <template #leftBlock>
      <LeftContent />
    </template>
    <template #rightBlock>
      <SignInForm @switch-to-signup="handleSwitchToSignup" />
    </template>
  </AuthLayout>
</template>

<script setup>
import { defineProps, inject } from "vue";
import AuthLayout from "layouts/AuthLayout/index.vue";
import SignInForm from "components/Forms/SignInform/index.vue";
import LeftContent from "./LeftContent.vue";
import { INJECT_KEYS } from "@/constants/injectKeys";

const props = defineProps({
  google: {
    type: String,
    required: true,
  },
  github: {
    type: String,
    required: true,
  },
});

// Get the toggle function from the parent layout
const toggleSignUp = inject(INJECT_KEYS.TOGGLE_SIGN_UP);

// Handle switching to signup
const handleSwitchToSignup = () => {
  if (toggleSignUp) {
    toggleSignUp(true);
  }
};
</script>
